export enum TimelineConnectionStatus {
    Disconnected,
    Connecting,
    Connected,
}
